import { call, put, select, take } from 'redux-saga/effects';

import { getToken, setWellFunnelToken } from 'api/utils/tokenManagement';
import api from 'api';

import { selectCurrentUser } from 'store/user/selectors';
import { GET_CURRENT_USER_ERROR, GET_CURRENT_USER_SUCCESS } from 'store/user/actionTypes';
import { getCurrentUserRequest } from 'store/user/actions';

import { Platform } from 'constants/api';

import ApiClientWellFunnel from 'services/api/ApiClientWellFunnel';

export function* waitForGetCurrentUser() {
    yield put(getCurrentUserRequest());

    const action: { type: string } = yield take([GET_CURRENT_USER_SUCCESS, GET_CURRENT_USER_ERROR]);

    if (action.type === GET_CURRENT_USER_ERROR) {
        throw new Error('Error while fetching user data');
    }
}

export function* getWFTokenForWebPlatform() {
    const { initial_platform } = yield select(selectCurrentUser);

    if (initial_platform === Platform.Web) {
        try {
            /* This is the only Wellfunnel endpoint that needs the auth-token-header set to the Yoga access token.
            The other Wellfunnel requests require a token-header containing the Wellfunnel token. */
            ApiClientWellFunnel.__instance__.defaults.headers['auth-token'] = getToken();
            const { token }: { token: string } = yield call(api.auth.getTokenWF);

            delete ApiClientWellFunnel.__instance__.defaults.headers['auth-token'];

            yield call(setWellFunnelToken, token);
        } catch {
            console.warn('Could not get Wellfunnel token');
        }
    }
}
